import React from 'react';

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import dayjs from "dayjs";


class CertificateCard extends React.Component {
    render() {
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: 'Акт',
                            icon: <CurrencyRubleIcon/>,
                            flat: true,
                            fields: [
                                {
                                    title: 'Сумма',
                                    value: this.props.certificate.revenue,
                                    xs: 12,
                                    sm: 12,
                                    md: 6,
                                    lg: 6,
                                },
                                {
                                    title: 'Дата',
                                    value: this.props.certificate.date?dayjs(this.props.certificate.date).format('DD MMM YYYY'):null,
                                    xs: 12,
                                    sm: 12,
                                    md: 6,
                                    lg: 6,
                                },
                                {
                                    title: 'Подписан',
                                    value: this.props.certificate.approval,
                                    xs: 12,
                                    sm: 12,
                                    md: 6,
                                    lg: 6,
                                },
                                {
                                    title: 'Получены оригиналы',
                                    value: this.props.certificate.papers,
                                    xs: 12,
                                    sm: 12,
                                    md: 6,
                                    lg: 6,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default CertificateCard